import RegConfirmation from './RegConfirmation';

export default RegConfirmation;
